module.exports = __webpack_public_path__ + "static/media/RBI.d1ca36cd.png";